import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {AppDataService} from '../../services/app-data.service';
import {MatDialog} from '@angular/material/dialog';
import {DialogPolicyComponent} from '../dialog-policy/dialog-policy.component';
import {DocumentService} from '../../services/document.service';
import { Subscription } from 'rxjs';
import { CartService } from '../../services/cart.service';

@Component({
    selector: 'my-portal-privacy-policy',
    template: `
        <a *ngIf="showPolicyPrivacy" (click)="openPolicy(true)">
            Política de privacidade
        </a>
        `,
    styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit, OnChanges, OnDestroy {
    currentCartItemsSubscription$!: Subscription;

    items: any;
    policy: any;
    checked: boolean = false;
    showPolicyPrivacy: boolean = false;
    personId: any = this.documentService.getWindow()?.sessionStorage.getItem('person');
    @Output() policyEvent = new EventEmitter();
    typeSearch: number = Number(this.documentService.getWindow()?.sessionStorage.getItem('typeSearch'));
    hotels: any;
    @Input() resetPolicyCheckbox?: boolean = false;
    @Input() isPrivacyPurchaseConfiguration?: boolean;


    constructor(private appService: AppDataService,
                public dialog: MatDialog,
                private cartService: CartService,
                private documentService: DocumentService) {
    }

    ngOnInit(): void {
            if (!this.isPrivacyPurchaseConfiguration) {
                this.getPolicy();
            }

            if (this.isPrivacyPurchaseConfiguration) {
                this.currentCartItemsSubscription$ = this.cartService.currentDataCartItems.subscribe((response: any) => {
                    if (response) {
                        this.items = response;
                        this.getPolicy(this.generateObjForDataPolicy());
                    }
                });
            }
    }

    generateObjForDataPolicy(): any {
        const obj: any = {};

        for (const hotel of Object.keys(this.items.hotels)) {
            obj[hotel] = {
                items: []
            };
            for (const itemCart of this.items.hotels[hotel].items) {
                obj[hotel].items.push({
                    tariff_id: itemCart.tarifa_id,
                    check_in: itemCart.check_in,
                    check_out: itemCart.check_out,
                });
            }
        }

        return obj;
    }

    getPolicy(data?: any): void {
        this.appService.getDataPolicy(data)
            .subscribe((response: any) => {
                this.showPolicyPrivacy = true;
                this.policy = response.data;
                this.hotels = (this.typeSearch < 6) ? this.policy : this.policy.privacity;

                this.showPolicyPrivacy = this.hasPolicy();
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.resetPolicyCheckbox?.currentValue) {
            this.checked = false;
        }
    }

    openPolicy(onlyRead: boolean): void {
        if (!this.hasPolicy()) {
            this.policyEvent.emit(true);
            return;
        }

        const dialogRef = this.dialog.open(DialogPolicyComponent, {
            maxHeight: '100dvh',
            data: {
                policyData: this.hotels,
                policyName: 'Política de privacidade',
                privacy: false,
                portal: (this.typeSearch < 6) ? false : true,
                onlyRead,
            },
            autoFocus: false,
        });

        dialogRef.afterClosed().subscribe((allTermsRead: boolean | undefined) => {
            if (allTermsRead) {
                this.policyEvent.emit(true);
            } else {
                this.policyEvent.emit(false);
            }
        })
    }

    private hasPolicy(): boolean {
        if (this.typeSearch < 6) {
            for (const hotel of Object.keys(this.hotels)) {
                return Boolean(this.hotels[hotel].policies.privacity);
            }
        } else {
            return Boolean(this.policy.privacity);
        }

        return false;
    }

    ngOnDestroy(): void {
        if (this.currentCartItemsSubscription$) {
            this.currentCartItemsSubscription$.unsubscribe();
        }
    }

}
